import { LuMoon, LuSun } from 'react-icons/lu';
import { useTheme } from '../lib/theme';

/**
 * The switch between the two themes.
 *
 * It shows where you are going, not where you are — a sun means "make it
 * light" — because a control that shows its own state leaves you guessing
 * what pressing it does. The title says it in words either way.
 */
export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const [theme, choose] = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  const label = next === 'light' ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <button
      type="button"
      className={`themetog${compact ? ' is-compact' : ''}`}
      onClick={() => choose(next)}
      title={label}
      aria-label={label}
    >
      {next === 'light' ? <LuSun size={14} aria-hidden="true" /> : <LuMoon size={14} aria-hidden="true" />}
      {compact ? null : <span>{next === 'light' ? 'Light' : 'Dark'}</span>}
    </button>
  );
}
